import React, { useCallback, useRef } from "react";

import { usePublicationStore } from "../../../store/store";
import { Layer } from "../../../types/publication";
import { hasSelectionModifier, isRightMouseClick, isToggleSelectClick } from "../utils/mouse-utils";

/** Click handling for the layer rows: plain click, ctrl/cmd-click (toggle) and shift-click (range). */
export function useLayerSelection() {
  const selectLayer = usePublicationStore((state) => state.selectLayer);
  const selectLayerRange = usePublicationStore((state) => state.selectLayerRange);
  const toggleLayerSelected = usePublicationStore((state) => state.toggleLayerSelected);

  // The last individually clicked layer, which a shift-click selects a range from.
  const anchorLayerIdRef = useRef<string | null>(null);

  const handleLayerClick = useCallback(
    (layer: Layer, e: React.MouseEvent) => {
      const isRightClick = isRightMouseClick(e);
      const hasModifier = hasSelectionModifier(e);

      // Right-clicking a selected row keeps the selection, so the context menu acts on all of it.
      if (isRightClick && layer.selected && !hasModifier) return;

      if (e.shiftKey && anchorLayerIdRef.current) {
        selectLayerRange(anchorLayerIdRef.current, layer.id);
      } else if (isToggleSelectClick(e)) {
        toggleLayerSelected(layer);
        anchorLayerIdRef.current = layer.id;
      } else {
        selectLayer(layer);
        anchorLayerIdRef.current = layer.id;
      }
    },
    [selectLayer, selectLayerRange, toggleLayerSelected]
  );

  return { handleLayerClick };
}
